import { gql } from "@apollo/client";

export const GENERATE_PRESIGNED_URL = gql`
  query getS3UploadUrlForDashboard($objectInput: GetS3UploadUrlForDashboardInput!) {
    getS3UploadUrlForDashboard(objectInput: $objectInput) {
      url
      fields
      objectKey
    }
  }
`;
